export default {"src":"/_next/static/media/oven.dca72fdc.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};